export const buildFreeTextRequest = query => ({
  rentalObject: { name: query.trim() },
  count: 1,
  dateFrom: null,
  dateTo: null,
  rentalHours: null,
});
